module.exports = __webpack_public_path__ + "img/heineken.83a8a381.png";